export default {
    keys: {
        cmsId: 'cmsid',
        id: 'id',
        dateStart: 'start',
        dateEnd: 'end',
        location: 'targets.id',
        banner: 'targetid',
        date: 'datestartasstring',
        genre: 'genres.id',
        tags: 'tags.id'
    },
    targets: {
        all: 'allelocaties',
        theatre: 'theaterdevest',
        church: 'grotekerk'
    },
    operators: {
        in: 'In',
        lowerThan: 'Lt',
        greaterThan: 'Gt',
        equals: 'Eq',
        notIn: 'NotIn'
    },
    inputTypes: {
        select: 'select',
        date: 'date',
        range: 'range',
        multiSelect: 'multiSelect',
        checkboxes: 'checkboxes',
        button: 'button',
        radioButtons: 'radio'
    },
    queryParams: {
        page: 'page',
        text: 'text',
    },
    cookies: {
        listBlockView: 'listBlockView',
    },
    magicStrings: {
        queryCount: '{{queryCount}}',
        totalCount: '{{totalCount}}',
    },
    priceTypes: {
        regulier: 'Regulier',
        random: 'Jijbepaaltwatjebetaalt'
    }
}